import CRUD from './crud'

export default new CRUD('coach-participants', 'superior-judge')
